export default "__VITE_ASSET__DF4RzlcG__"